import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
type props = {
  open: boolean;
  title?: string;
  handleClose: () => void;
  children: React.ReactNode;
};
const CustomDialog: React.FC<props> = ({
  handleClose,
  open,
  children,
  title,
}) => {
  const { t } = useTranslation(['auth']);
  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>{title && title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained">
          {t('warningButtonTitle')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
